<template>
  <div class="input-container">
    <h3 :for="id">{{ label }}<span v-if="required"> (Required) </span></h3>

    <input
      v-if="type !== 'textarea'"
      :id="id"
      :ref="id"
      v-model="model"
      :class="['no-shrink', 'full-width', { 'has-error': hasError }]"
      :placeholder="placeholder"
      :type="type"
      @blur="emitBlur()"
      @change="$emit('change', $event.target.value)"
      @update:model-value="$emit('update:modelValue', $event.target.value)"
    />

    <textarea
      v-if="type === 'textarea'"
      :id="id"
      :ref="id"
      v-model="model"
      :class="[
        'no-shrink',
        { 'has-error': hasError },
        { resizable: resizable },
      ]"
      :placeholder="placeholder"
      :style="{ height: $isDesktop ? '100px' : '150px' }"
      @blur="emitBlur()"
      @change="$emit('change', $event.target.value)"
      @update:model-value="$emit('update:modelValue', $event.target.value)"
    />

    <span
      v-if="hasError"
      class="input-error"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
/**
 * On io simulator, the blur / focus doesn't work
 * as expected.
 * ios : not initial focus, no blur > error focus
 */
export default {
  name: "Field",
  props: {
    modelValue: {
      type: [Array, Object, String, Number],
      required: true,
    },
    id: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    hasFocus: {
      type: Boolean,
    },
    label: {
      type: String,
      default: "",
    },
    hasError: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    resizable: {
      type: Boolean,
    },
  },
  emits: ["change", "update:modelValue", "blur-event"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    hasFocus(focus) {
      if (focus) {
        this.$nextTick(() => {
          this.$refs[this.id].focus();
        });
      }
    },
  },
  mounted() {
    if (this.hasFocus) {
      this.$nextTick(() => {
        this.$refs[this.id].focus();
      });
    }
  },
  methods: {
    emitBlur() {
      this.$emit("blur-event");
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 8px;
    padding-left: 2px;
    font-weight: bold;
  }

  .has-error {
    border: 1px solid $negative;
  }

  .input-error {
    color: $negative;
    font-weight: bold;
    padding-left: 2px;
  }

  textarea {
    resize: none;
  }

  .resizable {
    resize: both;
  }
}
</style>
